import { el } from './dom';
import { iconFor, type AlertMode } from './alert';

export interface ToastOptions {
    /** Milliseconds before auto-dismiss. Default 4000, 8000 for 'danger'. */
    delay?: number;
}

function container(): HTMLElement {
    let host = document.getElementById('McpToastContainer');
    if (!host) {
        host = el('div', 'toast-container position-fixed top-0 end-0 p-3');
        host.id = 'McpToastContainer';
        host.style.zIndex = '1090';
        document.body.appendChild(host);
    }
    return host;
}

/**
 * Floating, auto-dismissing notice (Bootstrap Toast, top-right, stacking).
 * For transient outcomes; use setAlertMessage when the notice should stay
 * with the form it concerns.
 */
export function toast(mode: AlertMode, title: string, message?: string | null, options: ToastOptions = {}): void {
    const delay = typeof options.delay === 'number' ? options.delay : (mode === 'danger' ? 8000 : 4000);

    const node = el('div', 'toast');
    node.setAttribute('role', 'alert');
    node.setAttribute('aria-live', 'polite');
    node.setAttribute('aria-atomic', 'true');

    const header = el('div', 'toast-header');
    header.appendChild(el('i', `${iconFor(mode)} me-2`));
    header.appendChild(el('strong', 'me-auto', title ?? ''));
    const close = el('button', 'btn-close');
    close.type = 'button';
    close.setAttribute('data-bs-dismiss', 'toast');
    close.setAttribute('aria-label', 'Close');
    header.appendChild(close);
    node.appendChild(header);
    if (message) node.appendChild(el('div', 'toast-body', message));

    container().appendChild(node);
    node.addEventListener('hidden.bs.toast', () => node.remove());

    const Toast = window.bootstrap?.Toast;
    if (Toast) {
        new Toast(node, { delay, autohide: true }).show();
    } else {
        // No Bootstrap on this page (tests, a stripped layout): still show, still go away.
        node.classList.add('show');
        setTimeout(() => node.remove(), delay);
    }
}
